/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Institutionid2Inputs */

const en__field_institutionid2 = /** @type {(inputs: _Field_Institutionid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institution`)
};

const de__field_institutionid2 = /** @type {(inputs: _Field_Institutionid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einrichtung`)
};

/**
* | output |
* | --- |
* | "Institution" |
*
* @param {_Field_Institutionid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_institutionid2 = /** @type {((inputs?: _Field_Institutionid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Institutionid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_institutionid2(inputs)
	return de__field_institutionid2(inputs)
});
export { _field_institutionid2 as "_field_institutionID" }